/* unplugin-vue-components disabled */import { render } from "./PopupIndustry.vue?vue&type=template&id=11789c34&ts=true"
import script from "./PopupIndustry.vue?vue&type=script&lang=ts"
export * from "./PopupIndustry.vue?vue&type=script&lang=ts"

import "./PopupIndustry.vue?vue&type=style&index=0&id=11789c34&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__